import Log from '../util/log';

const CHUNK_SIZE = 50000;

interface PageJson {
  page_id: string;
  meta: Record<string, string> | undefined;
  data: string;
  pages: number;
  current: number;
}

export default class Page {
  readonly id: string;

  readonly meta: Record<string, string> | undefined;

  readonly data: string;

  readonly pages: number;

  readonly current: number;

  constructor(
    id: string,
    meta: Record<string, string> | undefined,
    data: string,
    pages: number,
    current: number,
  ) {
    this.id = id;
    this.meta = meta;
    this.data = data;
    this.current = current;
    this.pages = pages;
  }

  public static createPages(
    id: string,
    meta: Record<string, string> | undefined,
    message: Record<string, any>,
  ): Page[] {
    const data = JSON.stringify(message);
    const pageCount = Math.ceil(data.length / CHUNK_SIZE);
    const pages: Page[] = [];

    for (let i = 0; i < pageCount; i += 1) {
      const sizeRemaining = Math.min(CHUNK_SIZE, data.length - i * CHUNK_SIZE);
      pages.push(
        new Page(
          id,
          meta,
          data.substring(i * CHUNK_SIZE, i * CHUNK_SIZE + sizeRemaining),
          pageCount,
          i,
        ),
      );
    }
    return pages;
  }

  public static createJsonFromPages(pages: Page[]): Record<string, any> {
    // incase for some reasons the array is not ordered
    const indexPage: Record<number, Page> = {};

    const count = pages[0].pages;

    pages.forEach((page) => {
      indexPage[page.current] = page;
    });

    let stringData = '';
    for (let i = 0; i < count; i += 1) {
      stringData += indexPage[i].data;
    }
    try {
      return JSON.parse(stringData) as Record<string, any>;
    } catch (error) {
      Log.warn('bridge page', error);
      return {};
    }
  }

  public static isPage(data: Record<string, any>): boolean {
    return !!data.page_id && data.pages !== undefined && data.current !== undefined;
  }

  public static from(data: Record<string, any>): Page | undefined {
    if (data.page_id && data.data && data.pages) {
      const page = data as PageJson;
      return new Page(page.page_id, page.meta, page.data, page.pages, page.current);
    }
    return undefined;
  }

  public toJson(): PageJson {
    return {
      page_id: this.id,
      meta: this.meta,
      data: this.data,
      current: this.current,
      pages: this.pages,
    };
  }
}
